import React, { createContext, useCallback, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import braintree, { Client, HostedFields, PayPalCheckout } from 'braintree-web';
import { getPaymentToken } from '../partnership/api';
import { PaymentTokenResponse } from '../partnership';

export type BraintreeContextValue = {
  error: Error | null;
  loading?: boolean;
  client?: Client;
  instance?: HostedFields;
  setInstance: (instance: HostedFields) => void;
  authToken: string;
};

const initialContext: BraintreeContextValue = {
  error: null,
  loading: false,
  client: undefined,
  instance: undefined,
  setInstance: () => {},
  authToken: '',
};


export const BraintreeContext = createContext<BraintreeContextValue>(initialContext);

export const BraintreeProvider: React.FC<{}> = ({ children }) => {
  const { data, error, isLoading } = useQuery<PaymentTokenResponse, Error>('paymentToken', () => getPaymentToken());
  const [client, setClient] = useState<Client>();
  const [instance, updateInstance] = useState<HostedFields>();
  const [authToken, setAuthToken] = useState<string>('');

  const initBraintree = useCallback(async (authorization: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    const newClient = await braintree.client.create({
      authorization: authorization,
    });
    setClient(newClient);
  }, [setClient]);

  useEffect(() => {
    if (data?.token) {
      void initBraintree(data.token);
      setAuthToken(data.token);
    }
  }, [data, initBraintree]);

  const setInstance = (newInstance: HostedFields) => {
    updateInstance(newInstance);
  };


  return (
    <BraintreeContext.Provider value={{
      error: error,
      loading: isLoading,
      client,
      instance,
      setInstance,
      authToken,
    }}>
      {children}
    </BraintreeContext.Provider>
  );
};